module.exports = __webpack_public_path__ + "static/header_picture-49425ffb144a1067bf459519962b7326.webp";